<template>
<!-- 公用弹窗 -->
            <!-- 此处是iframe网页 -->
            <!-- v-if="lin_k" -->
            <div class="if">
                 <div class="VR_style_bg" @click="none_wrap"></div>

                <div class="VR_style">
                  <!-- -->
            <div class="loader_wrp" v-if="VR_display" >
                  <!-- 此处是iframe网页 -->

                    <!-- 加载条勿动 -->
                <div class="loader" ref="loader">
                    <div class="loader-inner">
                        <div class="loader-line-wrap">
                        <div class="loader-line"></div>
                        </div>
                        <div class="loader-line-wrap">
                        <div class="loader-line"></div>
                        </div>
                        <div class="loader-line-wrap">
                        <div class="loader-line"></div>
                        </div>
                        <div class="loader-line-wrap">
                        <div class="loader-line"></div>
                        </div>
                        <div class="loader-line-wrap">
                        <div class="loader-line"></div>
                        </div>
                    </div>
                    </div>
            </div>
                    <div class="VR_style_left">
                          <iframe  id="iframe" style="height:100%"  allowfullscreen="true"  ref="iframe" frameborder=0 name="showHere"  scrolling=no :src="likeif"></iframe>
                    </div>

                    <div class="VR_style_right" id="something" ref="sortMenu">
                        <div class="VR_style_right_top">
                            <ul>
                                <li 
                                v-for="(item,index) in right_topdata" 
                                :class="{'right_topshow': index===indtop}" 
                                @click="right_topindex(index)"
                                :key="index">
                                <h1> {{item}}</h1>
                                   
                                </li>
                            </ul>
                            <span @click="close1"></span>
                        </div>

                        <div class="Canton_Fair" ref="id0">
                            <div class="Fair">
                                <h1>{{title}}</h1>
                                <!-- <div class="monitor_data">
                                    <div class="m1">面积:2000m</div>
                                    <div class="m2">4526</div>
                                </div> -->
                                <div class="Fair_p">
                                    {{des}}
                                </div>
                            </div>
                        </div>

                        <div class="recommend" ref="id1">
                            <h1>相关推荐</h1>
                            <ul>
                                <li>
                                    <img :src="recommend1" @click="clickrecommend1"/>
                                </li>
                                <li>
                                    <img :src="recommend2" @click="clickrecommend2"/>
                                </li>
                            </ul> 
                        </div>
                        <div class="QRCode" ref="id2">
                            <h1>二维码</h1>
                            <div class="qrcodebox">
                                 <div class="QR_loso">
                                                    <img src="../../assets/imges/logo.png"/>
                                </div>
                                <div id="qrcode" ref="qrcode"></div>
                                
                            </div>
                            
                        </div>


                    </div>
                </div>
            </div>
</template>
<script>
import QRCode from "qrcodejs2";
export default {
    data(){
        return{
            VR_display:true,
            a:0,
            b:0,
            c:0,
            // ,'推荐','二维码'
            right_topdata:['介绍'],
            indtop:0,
            likeif:"",
            title:"",
            des:"",
            recommend1:"",
            recommend2:"",
            recommendid:[],
            // 如果下一张为空的话
            Nextlink:'',
            // 如果上一张为空的话
            LastOne:''
        }
    },
    props: ['lin_k','codeid'],
    mounted() {
            var th_is = this
            this.$axios.post(
                "https://www.3dyunchuang.com/api/test/GetItemInfo2",
                this.$qs.stringify({
                    id:this.codeid,  
                    cate:this.lin_k,
                }),    
                )
                .then(res => {
                        this.likeif = res.data.data[0].link
                        this.des = res.data.data[0].des
                        this.title = res.data.data[0].title
                        this.recommend1 = 'http://oss.3dyunchuang.com/home_pic/vrgif/'+res.data.data[0].prv_img+"."+res.data.data[0].prv_type
                        this.recommend2 = 'http://oss.3dyunchuang.com/home_pic/vrgif/'+res.data.data[0].last_img+"."+res.data.data[0].last_type
                        this.Nextlink = res.data.data[0].last_link
                        this.LastOne = res.data.data[0].prv_link
                        this.recommendid[0] = (res.data.data[0].prv_id)
                        this.recommendid[1] = (res.data.data[0].last_id)
                        document.getElementById("qrcode").innerHTML = "";
                        let qrcode = new QRCode('qrcode',{
                            width: 117, // 设置宽度，单位像素
                            height: 120, // 设置高度，单位像素
                            text:th_is.likeif // 设置二维码内容或跳转地址
                        })
                    }) 
                    .catch(error => {                        
            });
            //一下原本是二级导航可以注释
            var aa=document.getElementById("something");
            aa.addEventListener("scroll", this.handleScroll, false);
            this.a= this.$refs.id0.getBoundingClientRect().top
            this.b = this.$refs.id1.getBoundingClientRect().top
            this.c = this.$refs.id2.getBoundingClientRect().top
            setTimeout(function(){
                th_is.$nextTick(function(){
                    th_is.VR_display = false
                })
            },600)
    },
    methods:{
        none_wrap(){
            this.close1()
        },
        right_topindex(index){
            this.indtop = index;
            var aa=document.getElementById("something");
            if(index == 0){
                aa.scrollTop=0;//不需要加单位
            }
            if(index == 1){
                let to2 = this.b - this.a; 
                aa.scrollTop=to2;//不需要加单位
            }
            if(index == 2){
                let to3 = this.c - this.a; 
                aa.scrollTop=to3;//不需要加单位
            }
        },
        handleScroll () {
            var sortMenu = this.$refs.sortMenu.scrollTop ;
            var aa=document.getElementById("something");
            let top = aa.scrollTop
            let to2 = this.b - this.a; 
            let to3 = this.c - this.a;  
            if(top < 10){
                this.indtop  = 0
            }
            if(top > 10 && top < to2){
                this.indtop  = 1
            }
            if(top > to2 && top < to3){
                this.indtop  = 2
            }
        },
        close1(){
             this.$emit('close1', 'true') // 触发父组件中handleChange事件并传参Jack
        },
        // 上一张
        clickrecommend1(){
         if(this.LastOne == "" || this.LastOne == null){
                return false
            }else{
                var th_is = this
                this.$axios.post(
                            "https://www.3dyunchuang.com/api/test/GetItemInfo2",
                            this.$qs.stringify({
                                id:this.recommendid[0],  
                                cate:this.lin_k,
                            }),    
                            )
                            .then(res => {
                                var qchoe = ""
                                if(res.data.data[0].cate == undefined){
                                        this.likeif = res.data.data[0].link
                                        qchoe = ""
                                }else{
                                        this.likeif = res.data.data[0].link
                                        qchoe = ""
                                }                
                                this.des = res.data.data[0].des
                                this.title = res.data.data[0].title
                                this.recommend1 = 'http://oss.3dyunchuang.com/home_pic/vrgif/'+res.data.data[0].prv_img+"."+res.data.data[0].prv_type
                                this.recommend2 = 'http://oss.3dyunchuang.com/home_pic/vrgif/'+res.data.data[0].last_img+"."+res.data.data[0].last_type
                                this.Nextlink = res.data.data[0].last_link
                                this.LastOne = res.data.data[0].prv_link
                                this.recommendid[0] = (res.data.data[0].prv_id)
                                this.recommendid[1] = (res.data.data[0].last_id)
                                document.getElementById("qrcode").innerHTML = "";
                                let qrcode = new QRCode('qrcode',{
                                        width: 117, // 设置宽度，单位像素
                                        height: 120, // 设置高度，单位像素
                                        text: qchoe + th_is.likeif // 设置二维码内容或跳转地址
                                })
                            
                });
            
            }
        },
        //下一张
        clickrecommend2(){
        if(this.Nextlink == "" || this.Nextlink == null){
                return false
            }else{
            var th_is = this
            this.$axios.post(
                        "https://www.3dyunchuang.com/api/test/GetItemInfo2",
                        this.$qs.stringify({
                            id:this.recommendid[1],  
                            cate:this.lin_k,
                        }),    
                        )
                        .then(res => {
                            var qchoe = "" 
                            if(res.data.data[0].cate == undefined){
                                    this.likeif = res.data.data[0].link
                                    qchoe = ""
                            }else{
                                    this.likeif = res.data.data[0].link
                                    qchoe = ""
                            }
                            this.des = res.data.data[0].des
                            this.title = res.data.data[0].title
                            this.recommend1 = 'http://oss.3dyunchuang.com/home_pic/vrgif/'+res.data.data[0].prv_img+"."+res.data.data[0].prv_type
                            this.recommend2 = 'http://oss.3dyunchuang.com/home_pic/vrgif/'+res.data.data[0].last_img+"."+res.data.data[0].last_type
                            this.Nextlink = res.data.data[0].last_link
                                this.LastOne = res.data.data[0].prv_link
                            this.recommendid[0] = (res.data.data[0].prv_id)
                            this.recommendid[1] = (res.data.data[0].last_id)
                             document.getElementById("qrcode").innerHTML = "";
                            let qrcode = new QRCode('qrcode',{
                                    width: 117, // 设置宽度，单位像素
                                    height: 120, // 设置高度，单位像素
                                    text: qchoe + th_is.likeif // 设置二维码内容或跳转地址
                            })
                                       
                });
            }
        }
    }
}
</script>
<style scoped>
.if{
    width: 100%;
    height: 100%;
    position: fixed;
    left: 0;
    top: 0;
    z-index: 9999;

}
.VR_style{
    padding:0 113px 0 105px;
    display: flex;
    flex-flow: row;
    height: 800px;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%,-50%);
    z-index: 1;
    position: relative;
    overflow: hidden;
}
.VR_style_bg{
    width: 100%;
    height: 100%;
    position: fixed;
    left: 0;
    top: 0;
    background:rgba(25,25,25,0.90);
}
.VR_style_left{
    flex: 1;
    pointer-events:auto;
    z-index: 1;
}
.VR_style_right{
    pointer-events:auto;
    width: 440px;
    /* height:800px; */
    background:#fff;
    overflow: hidden;
    overflow-y:auto;
    position: relative;
}
.VR_style_right::-webkit-scrollbar {
  width: 6px;
}

.VR_style_right::-webkit-scrollbar-track {
  background-color: #fff;
}

.VR_style_right::-webkit-scrollbar-thumb {
  background-color: #c5c5c5;
}
.VR_style_right_top{
    width: 433px;
    height: 54px;
    border-bottom: 1px solid #f3f3f3;
    position: fixed;
    background: #fff;
    margin-bottom: 20px;
}
.VR_style_right_top ul{
    padding: 0px 19px 0 19px;
}

.VR_style_right_top ul li{
    float: left;
    margin-right: 42px;
    line-height: 54px;
    color: #000000;
    cursor: pointer;
    font-size: 16px;
}
.VR_style_right_top span{
    width: 19px;
    height: 18px;
    background: url("../../assets/imges/dis_pnone.png") no-repeat;
    background-size: 100% 100%;
    display: block;
    float: right;
    margin-top: 15px;
    margin-right: 17px;
    cursor: pointer;
}
.Canton_Fair{
    width: 100%;
    /* height: 172px; */
    border-bottom: 1px solid #f3f3f3;
    padding-top: 28px;
    padding-bottom: 30px;
    margin-top:60px;
}
.Fair{
    padding: 0 30px 0 24px;
    
}
.Canton_Fair h1{
    font-size: 24px;
    margin-bottom: 10px;
}
.right_topshow{
    font-weight: bold;
}
.right_topshow h1{
    font-size: 18px;
}
.monitor_data{
    height: 20px;
    margin: 12px 0px;
    font-size: 12px;
}
.monitor_data .m1{
    float: left;
}
.monitor_data .m2{
    float: left;
    margin-left: 77px;
    background: url("../../assets/imges/m2.png") no-repeat left center;
    background-size: 21px 13px;
    padding-left: 25px;
    height: 18px;
}
.Fair_p{
    line-height: 26px;
    font-size: 15px;
}
.recommend{
    width: 100%;
    height: 200px;
    border-bottom: 1px solid #f3f3f3;
    margin-bottom: 20px;
}
.recommend h1{
    float: left;
    width: 100%;
    margin: 0px 0px 21px 20px;
    font-size: 18px;
}
.recommend ul{
    padding: 0px 0px 0px 18px;
    margin-top:20px;
}
.recommend ul li{
    width: 200px;
    height: 135px;
    margin-right: 10px;
    float: left;
    cursor: pointer;
}
.recommend ul li img{
    width: 100%;
    height: 100%;
}
#iframe{
  width: 100%;
  height: 100%;
  opacity: 1;
  transition: 1s all; 
}
.QRCode{
    width: 100%;
    height: 200px;

}
.QRCode h1{
    float: left;
    width: 100%;
    margin: 24px 0px 11px 20px;
    font-size: 18px;
}
.qrcodebox{
    float: left;
    margin-top: 50px;
    margin-left:155px;
    /* margin: 0px 0px 21px 20px; */
    height: 120px;
    width: 119px;
    padding: 5px;
    border: 1px  solid #f1f1f1;
    position: relative;
}
/* 加载条代码 */
.loader_wrp {
    width: calc(100% - 210px);
    height: 100%;
    position: absolute;
    left: 50%;
    top: 0px;
    z-index: 1;
     z-index: 999;
     transform:translateX(-50%);
     background: #000000;
    /* background: red; */
    /* padding:0 143px 0 135px;
    background: radial-gradient(#222, #000);
    overflow: hidden;
    z-index: 99999;
    overflow: hidden;
    position: absolute;
    left: 20px;
    top: 0px;
    width: 100%;
    height: 100%;
    border-radius: 10px; */
}

.loader-inner {
    bottom: 0;
    height: 60px;
    left: 0;
    margin: auto;
    position: absolute;
    right: 0;
    top: 0;
    width: 100px;
}

.loader-line-wrap {
    animation: 
		spin 2000ms cubic-bezier(.175, .885, .32, 1.275) infinite
	;
    box-sizing: border-box;
    height: 50px;
    left: 0;
    overflow: hidden;
    position: absolute;
    top: 0;
    transform-origin: 50% 100%;
    width: 100px;
}
.loader-line {
    border: 4px solid transparent;
    border-radius: 100%;
    box-sizing: border-box;
    height: 100px;
    left: 0;
    margin: 0 auto;
    position: absolute;
    right: 0;
    top: 0;
    width: 100px;
}
.loader-line-wrap:nth-child(1) { animation-delay: -50ms; }
.loader-line-wrap:nth-child(2) { animation-delay: -100ms; }
.loader-line-wrap:nth-child(3) { animation-delay: -150ms; }
.loader-line-wrap:nth-child(4) { animation-delay: -200ms; }
.loader-line-wrap:nth-child(5) { animation-delay: -250ms; }

.loader-line-wrap:nth-child(1) .loader-line {
    border-color: hsl(0, 80%, 60%);
    height: 90px;
    width: 90px;
    top: 7px;
}
.loader-line-wrap:nth-child(2) .loader-line {
    border-color: hsl(60, 80%, 60%);
    height: 76px;
    width: 76px;
    top: 14px;
}
.loader-line-wrap:nth-child(3) .loader-line {
    border-color: hsl(120, 80%, 60%);
    height: 62px;
    width: 62px;
    top: 21px;
}
.loader-line-wrap:nth-child(4) .loader-line {
    border-color: hsl(180, 80%, 60%);
    height: 48px;
    width: 48px;
    top: 28px;
}
.loader-line-wrap:nth-child(5) .loader-line {
    border-color: hsl(240, 80%, 60%);
    height: 34px;
    width: 34px;
    top: 35px;
}
.clickplay_qj{
    width: 100%;
    height: 100%;
    position: absolute;
    left: 0;
    top: 0;
    z-index: 999;
    opacity: 0;
}
@keyframes spin {
    0%, 15% {
		transform: rotate(0);
	}
	100% {
		transform: rotate(360deg);
	}
}
.QR_loso{
    z-index: 111;
    width: 40px;
    height: 40px;
    background: #fff;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%,-50%);
    border-radius: 30px;
    text-align: center;
}
.QR_loso img {
    width: 30px;
    height: 30px;
    margin-top: 5.5px;
}
</style>


// WEBPACK FOOTER //
// src/common/public/pop-upwindow.vue